import { call, put, select } from 'redux-saga/effects';
import { addToCart as addToCartAda } from '@bitComponents/adabyron/cqv2';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export function* addToCart(params) {
  const {
    cqId,
    chosenActionsArray,
    showPrices,
    reduxUpdate,
    normalizeHttpErrors,
  } = params;

  try {
    const { successUpdate } = reduxUpdate;
    const context = yield select(contextStore);
    const args = {
      cqId,
    };
    if (Array.isArray(chosenActionsArray)) {
      args.chosenActionsArray = chosenActionsArray;
    }
    if (showPrices) {
      args.showPrices = showPrices;
    }
    const response = yield call(addToCartAda, args, context);

    if (successUpdate) {
      yield put(successUpdate(response));
    }

    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.ADD_ITEMS_TO_CART, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
